import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { SseService } from 'src/app/services/SseService';
import { CookieService } from 'ngx-cookie-service';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { ApiService } from 'src/app/api.service';
import { GestionService } from 'src/app/services/gestion.services';
import {  Router } from '@angular/router';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { MAX_NOMBRE_CARTERA } from 'src/app/utils/nombre-cartera.util';

@Component({
  selector: 'app-gestor-dialog',
  templateUrl: './gestor-dialog.component.html',
  styleUrl: './gestor-dialog.component.scss'
})
export class GestorDialogComponent implements OnInit {

  listModelo: any;
  mercados: any;
  intervalos: any;
  licencia: string;
  public modeloSeleccionado: any;
  public optimaseleccionada: any;
  labelerror: any;
  readonly maxNombreCartera = MAX_NOMBRE_CARTERA;
  theme: string;

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<GestorDialogComponent>,
              private _sseservice: SseService, 
              private _cookieService: CookieService,
              private apiService: ApiService,
              private _gestionsv: GestionService,
              private _router: Router,
              public dialog: MatDialog,
              private toastr: ToastrService,
              ) {
  }

  disabledByAccount: boolean = false;

  accountType: string[] = [
    'MARGEN',
    'NOMINAL'
]

purchaseTypes: string[] = [
  'LIMITADO',
  'FIJO'
]

  optimalWallet: OptimalWallet = {
    apalancamiento: 1,
    bajista:false,
    capitalinicial: 100000,
    idcartera: 0,
    nombre: '',
    valorLiquidativo: 100000,
    valorliquidativoTemp: 0.0,
    riesgomaximo: 50.0,
    tipocuenta: 'MARGEN',
    tiporiesgo: 'LIMITADO',
    riesgo: 1000.0,
    comisionbroker: 10.0,
    idmercado: 8,
    intervalotiempo: 6,
    prima: false,
    participacion: false,
    simulado: true,
    poderCompra: 200000,
    numeroReconfiguracion: 0,
    stopLoss: 20,
    profit: 10,
    capitales:[ 1000.0, 1000.0],
    fondosDisponibles: 100000,
    margen: 0,
    margenRequeridoPor: 30,
    controlMarginCall: 75.0,
    lista: 0,
    nOperaciones: 0,
    maxDiferenciaCierres: 0.0,
    rendimientoNeto: 0.0,
    rendimientomedioanual: 0.0,
    rendimientoacumuladoanual: 0.0,
    tasacrecimientoanualcompuesto: 0.0,
    periodosoperativa: 0,
    beneficioneto: 0.0,
    beneficionetoporcentual: 0.0,
    mayorretrocesodesdemaximo: 0.0,
    mayorretrocesodesdemaximoporcentual: 0.0,
    mediabeneficioperdidaporcentual: 0.0,
    sumaresiduosbeneficioperdidaporcentual: 0.0,
    volatilidadperiodo: 0.0,
    volatilidadanual: 0.0,
    mesesdd: 0,
    maximoretrocesoperiodo: 0.0,
    sumarrendimientosanuales: 0.0,
    prombeneficiointervalo: 0.0,
    prombeneficionintervaloporcentual: 0.0,
    sumatorio: false,
    coeficientevolatilidadanual: 1.0,
    ratiobeneficioriesgo: 0.0,
    modelodesde: '',
    efectivo: 100000.0,
    gastosGestionPor: 1.0,
    gastosPrestamoPor: 8.0,
    nRecalcular: 0,
    idModelo: 0,
    liquidativos: null,
    sincro: true,auto:false, 
    idCarteras:[0,0,0,0,0],
    subCarteras: '',
    chkgastogest:true,
    chkgastoprest:true,
    chkcomisionbroker:true
}

  ngOnInit(): void {
    console.log("se ejecuta DIALOG ");
    this.licencia = this._cookieService.get('auth_token');
    this.theme = localStorage.getItem('theme') || 'light-theme';
    this.apiService.apiPost("listamercados", true, {}, 2).then((response) => {
      if (response.data) {
        this.mercados = response.data;
      }
    });
    this.apiService.apiPost("parametricaparamodelos",true,{},2).then((response)=>{
      this.intervalos=(response.data.periodos);
    });
    this.getListaCarteras();
  }

  submitForm() {

    this.dialogRef.close();
  }

  getListaCarteras(){
    this._sseservice.apiPostNew('listarcarteras',null, this.licencia ).subscribe(response => {
      let data = response;
      data = data.filter((item: { subCarteras: string; }) => item.subCarteras === "");

      this.listModelo = data;
      console.log(this.listModelo);
    });
  }

  disabledMargin(event: any) {
    if (this.optimalWallet.tipocuenta == 'MARGEN') {
        this.optimalWallet.poderCompra = 100000
        this.disabledByAccount = false;
    }
    else {
        this.optimalWallet.poderCompra = 200000
        this.disabledByAccount = true;
    }
}
  eliminarCartera(){
    if (this.modeloSeleccionado) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '200px',
        panelClass: this.theme,
        data: {
          msj: '!Atención! La Cartera  será eliminada en todos los módulos del programa.'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log('El diálogo se cerró');
        if (result) {
          const idcartera = {
            idcartera: Number(this.modeloSeleccionado)
          };
          this._sseservice.apiPostNew('eliminarcartera',idcartera, this.licencia).subscribe(response =>{
            console.log(response);
            this.getListaCarteras()
          });
        } else {
        
          console.log('La acción fue cancelada');
        }
      });
      
    } else {
      console.log("No se ha seleccionado ninguna cartera para eliminar.");
    }
  }
  abrirCartera(){
    console.log("GESTION DIALOG ", this.optimaseleccionada);
    this.optimaseleccionada.idModelo = 0;
    this._gestionsv.updategestOptimaWallet(this.optimaseleccionada);
    this.dialogRef.close();
    // Modificar esta línea para incluir el idcartera como parámetro de consulta en la URL
    this._router.navigate(['/gestor'], { queryParams: { idcartera: this.optimaseleccionada.idcartera } });
  }


  calcularData(){
    console.log("entro a calcular");
    this.optimalWallet.capitalinicial = this.optimalWallet.apalancamiento * 100000;
    this.optimalWallet.efectivo = this.optimalWallet.capitalinicial;
    this.optimalWallet.valorLiquidativo = this.optimalWallet.capitalinicial; 
    this.optimalWallet.fondosDisponibles = this.optimalWallet.capitalinicial; 
    this.optimalWallet.poderCompra = this.optimalWallet.capitalinicial ;
    this.optimalWallet.margen=0;
  }

  guardarCartera(){
    this.labelerror = '';
    console.log(this.optimalWallet);
    console.log(this.licencia);
    this.optimalWallet.idModelo=0;//Aqui es la linea
    if (this.optimalWallet.nombre != '') {
      this._sseservice.apiPostNew('registrarcartera', this.optimalWallet, this.licencia).subscribe(response => {
        console.log('Response registrarcartera,this.optimalWallet,this.licencia:', response);
        if (response.error == null) {
          this._gestionsv.updategestOptimaWallet(response);
          this.dialogRef.close();
          this._router.navigate(['/gestor']);
        } else {
          // El backend devuelve tanto "ya existe" como "supera N caracteres": se muestra tal cual.
          this.labelerror = response.error;
          console.log(response.error);
          this.toastr.error(response.error, 'Error', { timeOut: 30000, positionClass: 'toast-top-center' });
        }
      });
    } else {
      this.toastr.error('Debe Colocar Nombre Valido', 'Error', { timeOut: 3000, positionClass: 'toast-top-center' });
    }
  }

}
 

